export const DATE_FORMAT = 'dd/MM/yyyy';
export const CALENDAR_LOCALE = 'pt-BR';
